import Highlight from 'components/common/Highlight';
import { LinkButton } from 'components/inputs/LinkButton';
import { useFormik } from 'formik';
import { Box, Button, FormField, TextInput } from 'grommet';
import React from 'react';
import BounceLoader from 'react-spinners/BounceLoader';
import { dispatchAction } from 'rxbeach';
import { State } from 'types';
import { object, string } from 'yup';
import { login } from '../stream/actions';

const validationSchema = object({
  email: string().email().required(),
  password: string().required(),
});

interface LoginProps {
  state?: State;
  close?: Function;
}

const Login = ({ state, close }: LoginProps) => {
  const { touched, values, errors, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: {
        email: '',
        password: '',
      },
      validationSchema,
      onSubmit: ({ email, password }) => {
        dispatchAction(login({ email, password }));
      },
    });

  const loading = state === State.LOADING;

  return (
    <Box align="center" justify="center" pad="large" background="white">
      <Box width="medium" background="white">
        <FormField label="Email" error={touched.email && errors.email} required>
          <TextInput
            id="email"
            type="text"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        <FormField
          label="Passord"
          error={touched.password && errors.password}
          required
        >
          <TextInput
            id="password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        {state === State.ERROR && (
          <Highlight
            danger
            message="Beklager, den kombinasjonen fungerte ikke."
          />
        )}

        <Box gap="small" margin={{ top: 'medium' }}>
          <Button
            label="Logg inn"
            disabled={loading}
            primary
            onClick={() => handleSubmit()}
          />
          {close && (
            <Button label="Avbryt" disabled={loading} onClick={() => close()} />
          )}
          <LinkButton disabled={loading} to="/forgot" onClick={() => close?.()}>
            Glemt passord
          </LinkButton>
          {loading && (
            <Box>
              <BounceLoader size={40} color="#7D4CDB" loading={true} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
